var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessenger({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 34,
    viewBox: "0 0 37 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3584 27.8006L5.5851 29.3595L7.18888 25.4304L7.22141 25.3507L7.169 25.2824L6.324 24.1812L6.32361 24.1807C4.60261 21.9579 3.66469 19.2493 3.65 16.4612C3.65021 9.18253 9.78617 3.15272 18.5 3.15272C27.214 3.15272 33.35 9.18274 33.35 16.4615C33.35 23.7133 27.1691 29.7704 18.5 29.7704C15.878 29.7704 13.4802 29.2387 11.3844 28.2432L10.4695 27.8077L10.4154 27.7819L10.3584 27.8006ZM3.60424 32.9015L3.60412 32.9007L10.2198 30.7422C12.6062 31.8669 15.3897 32.5174 18.5 32.5174C29.3044 32.5174 36.15 24.6573 36.15 16.4615C36.15 8.2662 29.3749 0.405664 18.5 0.405664C7.62514 0.405664 0.85 8.2662 0.849999 16.4615L0.850001 16.4622C0.864977 19.8189 1.98262 23.0807 4.03602 25.7663L1.86117 31.0871C1.76143 31.3309 1.73499 31.5977 1.78512 31.8558C1.83524 32.114 1.95973 32.3523 2.14342 32.5428C2.32708 32.7332 2.56223 32.8679 2.8209 32.9313C3.07956 32.9948 3.35133 32.9844 3.60424 32.9015Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessenger);
export default __webpack_public_path__ + "static/media/Messenger.33eb17b5dfa01e0348509afbfdd15555.svg";
export { ForwardRef as ReactComponent };